import moment from 'moment'

import 'moment-timezone'

moment.tz.setDefault('Pacific/Auckland')

export default (ctx, inject) => {
  ctx.$moment = moment
  inject('moment', moment)
}
